import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.update()
  }

  update() {
    const disabled = !this.checkboxTarget.checked

    this.submitTarget.disabled = disabled
    this.submitTarget.classList.toggle("c-button--disabled", disabled)
  }
}
